<template>
	<div>
		<div v-if="isProgressShowing" class="p-4">
			<LoadingIndicator/>
		</div>

		<div v-else>

			<div v-if="!hasPaymentIntegrations" class="row mx-0 align-items-center my-4 text-center">
				<div class="col">
					<div class="mb-2">Please connect {{allowedIntegrationString}} for your client to pay.</div>
<!--					<div class="mb-4">-->
<!--						<small class="text-muted">Allow your clients to pay using credit card or PayPal-->
<!--&lt;!&ndash;							or set the instructions to manually pay invoices (including bank transfers).&ndash;&gt;-->
<!--						</small>-->
<!--					</div>-->
					<el-button class="" type="primary" size="small" :loading="isLoading" @click="connectPaymentMethodsClicked()">
						{{connectButtonText}}
					</el-button>
				</div>
			</div>
			<div v-else >
				<div class="mb-2">Client can pay with:</div>

				<AvailablePaymentMethodRow
					v-if="paymentIntegrations.payPalIntegration && paymentIntegrations.isPayPalIntegrated() && isPayPalAllowed"
					:paymentIntegrationItem="paymentIntegrations.payPalIntegration"/>

				<AvailablePaymentMethodRow
					v-if="paymentIntegrations.stripeIntegration && paymentIntegrations.isStripeIntegrated() && isStripeAllowed"
					:paymentIntegrationItem="paymentIntegrations.stripeIntegration"/>





				<div class="row mx-0 align-items-center my-4 text-center">
					<div class="col">

						<qw-button class="" type="primary" size="small" @click="showPaymentMethodsOptions = true"
						:analytics-props="analyticsProps">
							Manage payment methods
						</qw-button>
					</div>
				</div>

			</div>


		</div>


		<qw-drawer
			v-if="showPaymentMethodsOptions"
			v-model="showPaymentMethodsOptions"
			custom-class="bg-app-primary"
			:size="modalSize"
			:modal="modal"
			direction="rtl">
			<PaymentMethodsView
			:paymentIntegrations="paymentIntegrations"/>
		</qw-drawer>
	</div>
</template>

<script>
	import PaymentMethodsView from "@/core/modules/coach/Billing/view/PaymentIntegrations/PaymentMethodsView.vue";
	import AvailablePaymentMethodRow from "@/core/modules/coach/Coaching/Panels/ProgramBilling/AvailablePaymentMethodRow.vue";
	import LoadingIndicator from "@/core/components/LoadingIndicator.vue";

	import PaymentIntegrationType from "@shared/Billing/PaymentIntegrationType";
	import BasePaymentMethodsView
		from "@/core/modules/coach/Billing/view/PaymentIntegrations/BasePaymentMethodsView.vue";

	import IntegrationStatus from "@shared/Billing/IntegrationStatus"
	import PaymentIntegrations from "@shared/Billing/PaymentIntegrations";

	export default {
		extends: BasePaymentMethodsView,
		name: "PaymentMethodsManageView",
		components: {LoadingIndicator, AvailablePaymentMethodRow, PaymentMethodsView},
		props:{
			analyticsProps: Object,
			modal: {Boolean, default: true},
			modalSize: {String, default: "80%"},
			allowedIntegrations: {type: [Array, String], default: PaymentIntegrationType.ALL},
		},
		data: () => ({
			showPaymentMethodsOptions: false,
			paymentIntegrations: null,
			isLoading: false
		}),
		url: {
			showPaymentMethodsOptions: 'showIntegrations',
			integrationResult: 'res'
		},

		mounted() {
			this.loadPaymentMethods()
			this.integrationResult = null
		},

		methods: {
			async connectPaymentMethodsClicked(){
				if(this.isAllowedAll){
					this.showPaymentMethodsOptions = true
				} else {
					this.isLoading = true
					if(this.isStripeAllowed){
						await this.startStripeConnectionFlow()
					}
					this.isLoading = false
				}


			},
			async loadPaymentMethods() {
				this.paymentIntegrations = await this.handleAsync(this.$dataManager.getPaymentIntegrationsMain())
				this.$emit("paymentIntegrationsLoaded", this.paymentIntegrations)
			}
		},

		computed: {
			hasAllIntegrations(){
				if(this.paymentIntegrations.isStripeIntegrated() && this.allowedIntegrations === PaymentIntegrationType.STRIPE){
					return true
				}
				if(this.paymentIntegrations.isStripeIntegrated()
					&& this.paymentIntegrations.isPayPalIntegrated()
					&& this.allowedIntegrations === PaymentIntegrationType.ALL){
					return true
				}
				return false
			},

			hasPaymentIntegrations() {
				if(!this.paymentIntegrations){
					return false
				}

				if(this.allowedIntegrations === PaymentIntegrationType.STRIPE){
					return this.paymentIntegrations.isStripeIntegrated()
				}

				return this.paymentIntegrations.hasIntegrations()
			},

			allowedIntegrationString(){
				if(this.allowedIntegrations === PaymentIntegrationType.STRIPE){
					return "Stripe"
				}
				return "at least one method"
			},
			connectButtonText(){
				if(this.allowedIntegrations === PaymentIntegrationType.STRIPE){
					return "Connect Stripe"
				}
				return "Connect payment method"
			},

			isAllowedAll(){
				return this.allowedIntegrations === PaymentIntegrationType.ALL
			},

			isPayPalAllowed(){
				return this.isAllowedAll ||  this.allowedIntegrations === PaymentIntegrationType.PAYPAL
			},

			isStripeAllowed(){
				return this.isAllowedAll ||  this.allowedIntegrations === PaymentIntegrationType.STRIPE
			}
		}
	}
</script>

<style>

</style>
